import React, { useState, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { getLanguageString as _ } from "misc/lang";

import css from "./cookiebanner.module.scss";
import { CookieSettings } from "model/cookies";

export interface Props {
  cookies: CookieSettings;
  setCookies: (cookies: CookieSettings) => void;
}

const CookieBanner: React.FC<Props> = (props) => {
  const { cookies, setCookies } = props;
  const [hideBanner, setHideBanner] = useState<boolean>(true);

  const [experience, setExperience] = useState<boolean>(
    "experience" in cookies ? !!cookies.experience : true
  );
  const [performance, setPerformance] = useState<boolean>(
    "performance" in cookies ? !!cookies.performance : true
  );
  const [analytics, setAnalytics] = useState<boolean>(
    "analytics" in cookies ? !!cookies.analytics : true
  );

  useEffect(() => {
    window.setTimeout(() => setHideBanner(false), 3000);
  }, []);

  if ((cookies && cookies.date && !cookies.show) || hideBanner) return <></>;

  const actionRejectNonRequired = () => {
    setExperience(false);
    setPerformance(false);
    setAnalytics(false);

    const newCookies: CookieSettings = {};
    newCookies.required = true;
    newCookies.experience = false;
    newCookies.performance = false;
    newCookies.analytics = false;

    setCookies(newCookies);
  };

  const actionAcceptAll = () => {
    setExperience(true);
    setPerformance(true);
    setAnalytics(true);

    const newCookies: CookieSettings = {};
    newCookies.required = true;
    newCookies.experience = true;
    newCookies.performance = true;
    newCookies.analytics = true;

    setCookies(newCookies);
  };

  const acceptSelected = () => {
    const newCookies: CookieSettings = {};
    newCookies.required = true;
    newCookies.experience = experience;
    newCookies.performance = performance;
    newCookies.analytics = analytics;

    setCookies(newCookies);
  };

  return (
    <div className={css.coookieBanner}>
      <div className={css.content}>
        <div className={css.header}>
          Onelink.to uses cookies <span>(and similar technologies) </span>
        </div>

        <div className={css.info}>
          This service (Onelink.to) uses cookies and similar technologies to
          enhance the user experience <br />
          and performance, and to create better usage statistics using tools
          such as Google Analytics.
        </div>

        <div className={css.actions}>
          <div className={css.sliders}>
            <FormControlLabel
              control={<Switch checked={true} color="primary" />}
              label="Required"
              color="inherit"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={experience}
                  color="primary"
                  onChange={(event) =>
                    setExperience(event.currentTarget.checked)
                  }
                />
              }
              label="User Experience"
              color="inherit"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={performance}
                  color="primary"
                  onChange={(event) =>
                    setPerformance(event.currentTarget.checked)
                  }
                />
              }
              label="Performance"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={analytics}
                  color="primary"
                  onChange={(event) =>
                    setAnalytics(event.currentTarget.checked)
                  }
                />
              }
              label="Analytics"
            />
          </div>
          <div className={css.buttons}>
            <Button
              onClick={actionAcceptAll}
              variant="contained"
              color="primary"
              size="small"
            >
              {_("general", "button_accept_all_cookies")}
            </Button>
            <Button
              className={
                !experience && !performance && !analytics
                  ? css.disabled
                  : css.secondary
              }
              onClick={acceptSelected}
              variant="outlined"
              color="primary"
              size="small"
              disabled={!experience && !performance && !analytics}
            >
              {_("general", "button_accept_selected_cookies")}
            </Button>
            <Button
              className={css.secondary}
              onClick={actionRejectNonRequired}
              variant="outlined"
              color="primary"
              size="small"
            >
              {_("general", "button_reject_cookies")}
            </Button>
          </div>
        </div>
      </div>
      {cookies.date && (
        <div className={css.close}>
          <IconButton
            aria-label="upload picture"
            component="span"
            size="large"
            color="inherit"
            onClick={() => setCookies({ ...cookies, show: false })}
            title={_("general", "button_close")}
          >
            <CloseIcon color="inherit" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default CookieBanner;
